import sharedStyles from 'styles/css/SharedStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataMembershipEliteDoctorsPage } from "reduxx/actions/pages/membershipEliteDoctors";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import apiRequest from 'utils/apiRequest';
import { ELITE_DOCTORS_MEMBERSHIP } from 'apis'; 

const MembershipEliteDoctors = () => {

    const dispatch = useDispatch();

    const { inputFullname, inputMedicalSystemNumber, inputExpertiseLevel, inputSpecializedField, inputMobile, inputSecretaryMobile, inputEmail, inputAddress, inputTelephone } = useSelector(state => state.eliteDoctorsMembership);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        if(name === 'inputMobile' || name === 'inputSecretaryMobile' || name === 'inputMedicalSystemNumber' || name === 'inputTelephone')
            dispatch(handleChangeDataMembershipEliteDoctorsPage(name, value));
        else
            dispatch(handleChangeDataMembershipEliteDoctorsPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

    const handleSubmitForm = (event) => {
        event.preventDefault();

        if(inputFullname.trim().length < 3) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام و نام خانوادگی خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else if(inputMedicalSystemNumber.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'شماره نظام پزشکی   را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(! inputExpertiseLevel)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'سطح تخصص را مشخص کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputSpecializedField.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'رشته تخصصی را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputMobile.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل  پزشک را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputMobile.trim().length !== 11)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل   پزشک باید 11 رقم باشد  ', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputSecretaryMobile.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل  منشی را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputSecretaryMobile.trim().length !== 11)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل   منشی باید 11 رقم باشد  ', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputEmail.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'ایمیل را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputAddress.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'آدرس را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputTelephone.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'تلفن  را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else {
            if(! isBackdropLoading) {
                apiRequest({
                    dispatch,
                    endpoint: ELITE_DOCTORS_MEMBERSHIP,
                    method: 'post',
                    data: { 
                        fullname: inputFullname, 
                        medicalSystemNumber: inputMedicalSystemNumber, 
                        expertiseLevel: inputExpertiseLevel, 
                        specializedField: inputSpecializedField, 
                        mobile: inputMobile, 
                        secretaryMobile: inputSecretaryMobile, 
                        email: inputEmail, 
                        address: inputAddress,
                        telephone: inputTelephone 
                    },
                    token: null,
                    successMessage: 'درخواست شما با موفقیت ثبت شد',
                    onSuccess: (res) => {
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputFullname', ''));
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputMedicalSystemNumber', ''));
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputExpertiseLevel', ''));
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputSpecializedField', ''));
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputMobile', ''));
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputSecretaryMobile', ''));
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputEmail', ''));
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputAddress', ''));
                        dispatch(handleChangeDataMembershipEliteDoctorsPage('inputTelephone', ''));
                        // navigate(`verify`);
                    },
                });
            }

        }
    };

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                

                <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary']].join(' ')}>
                    دکتربیست  از تمامی پزشکان نخبه در هر سه سطح
                </div>

                <p className={[formStyles['text-center'], ruleStyles['font-weight-800']].join(' ')}>
                    سطح یک : پزشکان عمومی (GP)
                </p>

                <p className={[formStyles['text-center'], ruleStyles['font-weight-800']].join(' ')}>
                    سطح دو: پزشکان متخصص 
                </p>

                <p className={[formStyles['text-center'], ruleStyles['font-weight-800']].join(' ')}>
                    سطح سه: پزشکان فلوشیپ و فوق تخصص 
                </p>

                <p className={formStyles['text-center']}>
                    دعوت به همکاری بصورت Percase میکند.
                </p>

                <p className={formStyles['text-center']}>
                    (هم مشاوره ی پزشکی وصدور نسخه الکترونیک )
                </p>

                <p className={formStyles['text-center']}>
                    و (هم جراحی های الکتیو و غیر اورژانس برای موارد توریسم درمانی)
                </p>






                <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary'], sharedStyles['mt-[64px]']].join(' ')}>
                    فرم درخواست همکاری پزشکان عزیز با دکتربیست
                </div>

                <input type="text" name="inputFullname" value={inputFullname} onChange={handleChangeInputs} className={[formStyles.input, sharedStyles['mt-[16px]']].join(' ')} placeholder="نام و نام خانوادگی" />
                <input type="text" name="inputMedicalSystemNumber" value={inputMedicalSystemNumber} onChange={handleChangeInputs} className={formStyles.input} placeholder="شماره نظام پزشکی" />
                <select name="inputExpertiseLevel" value={inputExpertiseLevel} onChange={handleChangeInputs}  className={formStyles.input}>
                    <option>سطح تخصص</option>
                    <option>فوق تخصص</option>
                    <option>فلوشیپ</option>
                    <option>تخصص با مدرک بورد تخصصی</option>
                    <option>عمومی</option>
                </select>
                <input type="text" name="inputSpecializedField" value={inputSpecializedField} onChange={handleChangeInputs} className={formStyles.input} placeholder="رشته تخصصی" />
                <input type="tel" name="inputMobile" value={inputMobile} onChange={handleChangeInputs} className={formStyles.input} placeholder="موبایل پزشک" style={{direction: 'rtl'}} />
                <input type="tel" name="inputSecretaryMobile" value={inputSecretaryMobile} onChange={handleChangeInputs} className={formStyles.input} placeholder="موبایل منشی" style={{direction: 'rtl'}} />
                <input type="email" name="inputEmail" value={inputEmail} onChange={handleChangeInputs} className={formStyles.input} placeholder="ایمیل" style={{direction: 'rtl'}} />
                <input type="text" name="inputAddress" value={inputAddress} onChange={handleChangeInputs} className={formStyles.input} placeholder="آدرس مطب" style={{direction: 'rtl'}} />
                <input type="tel" name="inputTelephone" value={inputTelephone} onChange={handleChangeInputs} className={formStyles.input} placeholder="تلفن مطب (با ذکر پیش شماره )" style={{direction: 'rtl'}} />
                <button onClick={handleSubmitForm} className={formStyles.button}>ارسال</button>


            </div>
                
        </div>

    );
}

export default MembershipEliteDoctors;